var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/slovenia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/slovenia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slovenia",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.077,166.957 L222.609,166.957 L222.609,100.174 L89.043,100.174 L89.043,166.957 L15.923,166.957 C5.633,194.689 0,224.686 0,256 C0,287.314 5.633,317.31 15.923,345.043 L256,367.304 L496.077,345.043 C506.367,317.31 512,287.314 512,256 C512,224.686 506.367,194.689 496.077,166.957 Z",
    id: "Path",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C366.071,512 459.906,442.528 496.077,345.043 L15.923,345.043 C52.094,442.528 145.929,512 256,512 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.043,166.957 L89.043,189.217 C89.043,240.338 155.826,256.001 155.826,256.001 C155.826,256.001 222.609,240.338 222.609,189.217 L222.609,166.957 L200.348,189.218 L155.826,155.827 L111.304,189.218 L89.043,166.957 Z",
    id: "Path",
    fill: "#F0F0F0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/SI.31f9e2608e52af61c77022910858efd8.svg";
export { ForwardRef as ReactComponent };